import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'scitis-dashboard-locations',
    templateUrl: './dashboard-locations.component.html',
    styleUrls: ['./dashboard-locations.component.scss'],
    standalone: false
})
export class DashboardLocationsComponent {

  @Input()
  public machineCount: number = 0;

  @Input()
  public locationsAggregate: Map<string, number> = new Map<string, number>();

  @Output()
  public locationChanged: EventEmitter<string> = new EventEmitter<string>();

  public location: string = '';
  public searchedLocation: string = '';

  onLocationChange(location: string) {
    this.location = location;
    this.locationChanged.emit(location);
  }

  public getFilteredLocations(): Map<string, number> {
    if (!this.searchedLocation || this.searchedLocation.isNullOrWhitespace()) {
      return this.locationsAggregate;
    }

    const result: Map<string, number> = new Map<string, number>();
    this.locationsAggregate.forEach((value, key) => {
      if (key.toLowerCase().indexOf(this.searchedLocation.toLowerCase()) > -1) {
        result.set(key, value);
      }
    });
    return result;
  }
}
